import React, { useEffect, useState } from "react";
import withLayout from "../../../src/layouts/withLayout";
import { Breadcrumb, Divider } from "antd";
import { article } from "@Api";
import IframeCommentListPage from "../../../src/components/article/articlesRemark/IframeCommentListPage";
import { EyeOutlined } from "@ant-design/icons";

const { fatchArticleDetails, fatchArticleSevenDaysHot } = article;

interface IArticleDetail {
  id: string;
  title: string;
  type: string;
  url: string;
}
interface IArticleSevenDaysHot {
  cover: string;
  id: string;
  isNum: string;
  title: string;
  url: string;
}

const ArticlesRemarkPage: React.FC = ({}) => {
  const { id, type } = window.article;
  const [articleDetail, setArticleDetail] = useState<IArticleDetail>();
  const [articleSevenDaysHot, setArticleSevenDaysHot] = useState<[IArticleSevenDaysHot]>();

  const getDetail = async () => {
    try {
      const res: { data; status } = await fatchArticleDetails({ id, type });
      if (res.status == "12000") {
        setArticleDetail(res.data.article);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSevenDaysHot = async () => {
    try {
      const res: { data; status } = await fatchArticleSevenDaysHot({ id, type, limit: 5 });
      if (res.status == "12000") {
        setArticleSevenDaysHot(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDetail();
    getSevenDaysHot();
  }, [window.article]);

  return (
    <section className={"mx-auto my-20"}>
      <div className='flex justify-between items-center text-16 w-1190 mx-auto'>
        <Breadcrumb separator='>'>
          <span className='text-[#333333] text-16'>您當前的位置：</span>
          <Breadcrumb.Item href='/' className={"text-16"}>
            新聞
          </Breadcrumb.Item>
          <Breadcrumb.Item href='/' className={"text-16"}>
            評論頁
          </Breadcrumb.Item>
        </Breadcrumb>

      </div>

      <Divider className='h-4 bg-[#EDEDED]' />

      <div className='flex w-1190 mx-auto'>
        <div className='w-850'>
          <a href={articleDetail?.url} className='inline-block text-34 mb-38'>
            <h1 className='font-normal hover:text-[#1890ff] leading-[normal]'>{articleDetail?.title}</h1>
          </a>
          <IframeCommentListPage />
        </div>
        {Array.isArray(articleSevenDaysHot) && articleSevenDaysHot.length > 0 && (
          <div className='w-310'>
            <h3 className='text-24 mb-22 font-normal'>七天熱門文章</h3>
            <div className='ArticleList'>
              {articleSevenDaysHot.map((v, i) => (
                <a href={v.url} key={i}>
                  <div className='w-full h-90 mb-20 flex'>
                    <div className='w-120 h-full '>
                      <img src={v.cover} alt={v.title} className='object-cover w-120 h-full' />
                    </div>
                    <div className='relative pl-14'>
                      <div className='text-14 line-clamp-2 text-[#333]'>{v.title}</div>
                      <div className='absolute bottom-0 right-0 text-14 text-[#999] flex items-center'>
                        <EyeOutlined className="mr-4 text-16"/>
                        {v.isNum}
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

withLayout({
  cmp: <ArticlesRemarkPage />,
  params: {
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
    needRTBH: true,
  },
});
